import React, { useMemo } from "react";
import DOMPurify from "dompurify";
import "../Styles/SafeMap.css";

const SafeMap = ({ mapHtml }) => {

  const cleanHtml = useMemo(() => {
    if (typeof mapHtml !== "string") return "";

    console.log("Original HTML:", mapHtml);

    // Step 1: Sanitize
    const sanitized = DOMPurify.sanitize(mapHtml, {
      ALLOWED_TAGS: [
        "p",
        "br",
        "hr",
        "strong",
        "b",
        "i",
        "u",
        "em",
        "ul",
        "ol",
        "li",
        "span"
      ],
      ALLOWED_ATTR: ["style"]
    });

    console.log("After DOMPurify:", sanitized);

    // Step 2: Remove nbsp + cleanup
    const finalHtml = sanitized
      .replace(/&amp;nbsp;/gi, "")
      .replace(/&nbsp;/gi, "")
      .replace(/\u00A0/g, "")
      // .replace(/<p>\s*<\/p>/gi, "")
      .replace(/(<br\s*\/?>\s*){2,}/gi, "<br>")
      .trim();

    console.log("Final Clean HTML:", finalHtml);

    return finalHtml;

  }, [mapHtml]);

  if (!cleanHtml) return null;

  return (
    <div className="safeMap-container">
      <div
        className="safeMap-content"
        dangerouslySetInnerHTML={{ __html: cleanHtml }}
      />
    </div>
  );
};

export default SafeMap;
